import { render, staticRenderFns } from "./TabYourDetails.vue?vue&type=template&id=575f46cd&"
import script from "./TabYourDetails.vue?vue&type=script&lang=js&"
export * from "./TabYourDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports